import { Button } from 'antd';
import React, { useMemo, useState } from 'react';

import { OffersImportDrawer } from '../components/OfferBulk/OffersImportDrawer';

type DrawerOfferBulkProps = {
  onSuccessFinishImport?: () => void;
};

export type DrawerOfferBulkType = React.FC<DrawerOfferBulkProps>;

export function useOfferBulkImport() {
  const [isOpenProductsImportDrawer, setIsOpenProductsImportDrawer] =
    useState(false);
  const ActionsOfferBulk = useMemo(() => {
    return () => (
      <>
        <Button
          color='primary'
          variant='outlined'
          onClick={() => {
            setIsOpenProductsImportDrawer(true);
          }}
        >
          Criar ofertas em massa
        </Button>
      </>
    );
  }, []);

  const DrawerOfferBulk = useMemo<DrawerOfferBulkType>(() => {
    return ({ onSuccessFinishImport }) => (
      <OffersImportDrawer
        onClose={() => setIsOpenProductsImportDrawer(false)}
        onSuccessFinishImport={onSuccessFinishImport}
        open={isOpenProductsImportDrawer}
      />
    );
  }, [isOpenProductsImportDrawer]);

  return {
    ActionsOfferBulk,
    DrawerOfferBulk,
  };
}
